import { twMerge } from 'tailwind-merge';
import Banner from './Banner';
import { IKeyBannerProperty } from '@/interfaces/homepage';

export const ModuleBanner = ({ banner, children, isHomepage }: { banner: IKeyBannerProperty; children?: React.ReactNode; isHomepage?: boolean }) => {
  return (
    <Banner
      image={banner?.Image}
      video={banner?.Video}
      background={banner?.Background}
      bannerType={banner?.BannerType}
      contentClassName={twMerge(
        'h-auto md:min-h-[250px] w-full',
        isHomepage ? 'aspect-[4/3] md:aspect-[5/2]' : 'aspect-[1535/720] md:aspect-[1911/475]',
      )}
    >
      <div>
        <div className="absolute bottom-0 top-0 flex w-full items-start justify-end lg:text-white">
          <div className="container h-full">
            <div className="relative h-full">{children}</div>
          </div>
        </div>
      </div>
    </Banner>
  );
};
